import React from 'react';

interface LogoImageProps {
  currentFunds: {
    imageUrl?: string;
  }[];
}

const LogoImage: React.FC<LogoImageProps> = ({ currentFunds }) => {
  if (currentFunds[0] && currentFunds[0]['imageUrl']) {
    const imgURL = currentFunds[0]['imageUrl'];
    return (
      <img
        className="lil-rounded-md"
        src={`https://assets1.cleartax-cdn.com/clearsave${imgURL}`}
        width="100"
        alt="Fund logo"
      />
    );
  }

  return null;
};

export default LogoImage;



// WEBPACK FOOTER //
// ./components/amcNew/LogoImage.tsx